/**
 * Hook to detect mobile devices (Android, iPhone, iPad, iPod)
 * Uses multiple detection methods to distinguish actual mobile devices from desktop browsers
 * @returns boolean indicating if the current device is a mobile device
 */
export const useDeviceDetection = () => {
  const userAgent = navigator.userAgent;

  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
  const isAndroid = /android/i.test(userAgent);

  // Check for desktop OS in user agent (DevTools often changes UA but keeps some desktop indicators)
  const hasDesktopOS =
    /Macintosh|Windows|Linux x86_64|X11/i.test(userAgent) && !isAndroid;

  // Use modern userAgentData API if available (not fooled by DevTools UA override)
  const userAgentData = (navigator as any).userAgentData;
  const isMobileFromAPI = userAgentData?.mobile ?? null;

  // Determine if mobile:
  // 1. If userAgentData is available, trust that (it's not easily spoofed by DevTools)
  // 2. Otherwise, check if has mobile UA but no desktop OS indicators
  const isMobileDevice =
    isMobileFromAPI !== null
      ? isMobileFromAPI
      : (isIOS || isAndroid) && !hasDesktopOS;

  return {
    isMobileDevice,
    isIOS,
    isAndroid,
  };
};
